import { cn } from '@/shared/lib/utils';
import { Checkbox } from '@/shared/ui/checkbox/Checkbox';
import type { SelectOption } from '../helpers/types';
import { normalizeOptionValue } from '../helpers/utils';

type MultipleSelectPopoverContentProps = {
  filteredOptions: SelectOption[];
  selectedValues: string[];
  toggleValue: (optionValue: string | number) => void;
  activeIndex: number;
  id?: string;
  listboxId?: string;
};

export const MultipleSelectPopoverContent = ({
  filteredOptions,
  selectedValues,
  toggleValue,
  activeIndex,
  id,
  listboxId,
}: MultipleSelectPopoverContentProps) => {
  return (
    <div
      role="listbox"
      id={listboxId}
      aria-multiselectable="true"
      className="max-h-64 overflow-y-auto"
    >
      {filteredOptions.length > 0 ? (
        filteredOptions.map((option, index) => {
          const normalizedValue = normalizeOptionValue(option.value);
          const isSelected = selectedValues.includes(normalizedValue);
          return (
            <div
              key={normalizedValue}
              role="option"
              id={id ? `${id}-option-${index}` : undefined}
              aria-selected={isSelected}
              tabIndex={-1}
              onClick={() => toggleValue(option.value)}
              onMouseDown={(e) => e.preventDefault()}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  toggleValue(option.value);
                }
              }}
              className={cn(
                'flex w-full cursor-pointer items-center gap-3 rounded-md px-3 py-2 text-left text-sm',
                'hover:bg-muted',
                index === activeIndex && 'bg-surface-accent',
              )}
            >
              <Checkbox checked={isSelected} aria-hidden />
              <span className="flex-1">{option.label}</span>
            </div>
          );
        })
      ) : (
        <div className="py-6 text-center text-sm text-text-muted">検索結果がありません</div>
      )}
    </div>
  );
};
